import TamanioForm from './TamanioForm'
export {TamanioForm}
export default TamanioForm
